import _ from 'lodash';
import React from 'react';

import { OrderPropertyName } from 'generated/graphql';
import { ImportCsvModal } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as importCsvSettings from './importCsvSettings';



const ImportCsvModalComponent = ImportCsvModal.genComponent<OrderPropertyName>();



export interface IProps {
  storeId: string;

  onCancel: () => void;
  onAccept: () => void;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.storeId);
  const [importOrdersFromCsv, importOrdersFromCsvTuple] = dataService.useImportOrdersFromCsv(props.storeId, tuple.data.prefixNewOrders);
  const [preValidateCsvImport, preValidateCsvImportTuple] = dataService.usePreValidateCsvImport(props.storeId, tuple.data.prefixNewOrders);

  const isLoading = importOrdersFromCsvTuple.loading || preValidateCsvImportTuple.loading;



  const processImport = React.useCallback(
    async (rows: Array<_.Dictionary<string>>) => {
      const validationErrors = await preValidateCsvImport(rows, tuple.data);
      if (_.isEmpty(validationErrors)) {
        importOrdersFromCsv(rows, tuple.data);
      } else {
        const errorMessage = _.join(validationErrors, '\n');
        alert(errorMessage);
      }
    },
    [
      importOrdersFromCsv,
      preValidateCsvImport,
      tuple.data
    ]
  );



  function handleAccept() {
    props.onAccept();
  }



  return (
    <ImportCsvModalComponent
      isOpen
      isLoading={isLoading}
      title="Import Orders"
      columnDescriptions={tuple.data.columnDefs}
      formatType2Comment={importCsvSettings.propertyName2Comment}
      formatType2Data={importCsvSettings.propertyName2Data}
      fnImport={processImport}
      onCancel={props.onCancel}
      onAccept={handleAccept} />
  );
};
